module.exports = __webpack_public_path__ + "assets/pdf/BN02-cn-urban-flood.4be2b9a3.pdf";